import React from 'react'
import { ExternalLink } from 'lucide-react'

interface BlogResourceItemProps {
  url: string
  title?: string
}

const BlogResourceItem: React.FC<BlogResourceItemProps> = ({ url, title }) => {
  const getDomain = (link: string) => {
    try {
      return new URL(link).hostname.replace('www.', '')
    } catch {
      return ''
    }
  }

  const domain = getDomain(url)

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className="block w-64 sm:w-56 bg-[#FAFAFA] border border-[#EAEBEB] rounded-lg p-4 hover:shadow-md transition-shadow"
    >
      <div className="flex items-center gap-2 text-xs text-gray-500 mb-2">
        <ExternalLink className="w-4 h-4" />
        <span className="truncate">{domain || 'Article'}</span>
      </div>
      <h3 className="text-sm font-medium text-gray-800 line-clamp-2">{title || domain || 'Resource'}</h3>
    </a>
  )
}

export default BlogResourceItem

